import React, { useState, useEffect } from "react";

const Tag = ({ children, color = "#FF5C2B" }) => (
  <span style={{
    display: "inline-block",
    background: color + "22",
    color: color,
    border: `1px solid ${color}55`,
    borderRadius: 4,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    padding: "4px 10px",
    marginBottom: 16,
  }}>{children}</span>
);

const CTAButton = ({ children, onClick, fullWidth }) => (
  <button onClick={onClick} style={{
    display: "block",
    width: fullWidth ? "100%" : "auto",
    margin: fullWidth ? "0" : "0 auto",
    background: "linear-gradient(135deg,#FF5C2B 0%,#E8421A 100%)",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    padding: "16px 36px",
    fontSize: 17,
    fontWeight: 700,
    cursor: "pointer",
    letterSpacing: "0.03em",
    boxShadow: "0 4px 24px #FF5C2B55",
    transition: "transform 0.15s, box-shadow 0.15s",
  }}
    onMouseOver={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 8px 32px #FF5C2B77"; }}
    onMouseOut={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 24px #FF5C2B55"; }}
  >{children}</button>
);

const Check = ({ children, color = "#1E9E6B" }) => (
  <div style={{ display: "flex", gap: 14, alignItems: "flex-start", marginBottom: 14 }}>
    <span style={{
      minWidth: 24, height: 24,
      background: color + "22", color,
      borderRadius: "50%", display: "flex",
      alignItems: "center", justifyContent: "center",
      fontWeight: 700, fontSize: 13, marginTop: 2,
    }}>✓</span>
    <p style={{ color: "#C8D4E8", fontSize: 16, lineHeight: 1.6, margin: 0 }}>{children}</p>
  </div>
);

const FAQItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: "1px solid #1F2D45", padding: "20px 0" }}>
      <button onClick={() => setOpen(!open)} style={{
        background: "none", border: "none", color: "#F5F7FA",
        fontSize: 16, fontWeight: 600, cursor: "pointer",
        display: "flex", justifyContent: "space-between",
        width: "100%", textAlign: "left", padding: 0, gap: 12,
      }}>
        <span>{q}</span>
        <span style={{ color: "#FF5C2B", fontSize: 22, transform: open ? "rotate(45deg)" : "none", transition: "transform 0.2s", flexShrink: 0 }}>+</span>
      </button>
      {open && <p style={{ color: "#7A8FA8", fontSize: 15, lineHeight: 1.7, marginTop: 12, marginBottom: 0 }}>{a}</p>}
    </div>
  );
};

export default function George() {
  const scrollToCTA = () => document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div style={{ fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif", background: "#0A0F1E", color: "#F5F7FA", margin: 0, padding: 0, overflowX: "hidden" }}>

      {/* HERO */}
      <section style={{
        minHeight: "100vh", display: "flex", alignItems: "center",
        justifyContent: "center", textAlign: "center",
        padding: "80px 24px",
        background: "radial-gradient(ellipse 70% 60% at 50% 0%, #FF5C2B18, transparent), #0A0F1E",
        position: "relative",
      }}>
        <div style={{
          position: "absolute", inset: 0,
          backgroundImage: "linear-gradient(#1F2D4522 1px,transparent 1px),linear-gradient(90deg,#1F2D4522 1px,transparent 1px)",
          backgroundSize: "60px 60px", pointerEvents: "none",
        }} />
        <div style={{ maxWidth: 780, position: "relative" }}>
          <Tag>While You Read This — Someone Just Lost a Job to Voicemail</Tag>

          {/* SHORTENED HERO TEXT ONLY */}
          <h1 style={{ fontSize: "clamp(34px,6vw,58px)", fontWeight: 900, lineHeight: 1.1, margin: "0 0 20px", letterSpacing: "-0.02em" }}>
            Every day without a lead system,{" "}
            <span style={{ background: "linear-gradient(90deg,#FF5C2B,#FFD166)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
              your competitors win more jobs.
            </span>
          </h1>

          <p style={{ fontSize: "clamp(16px,2.2vw,19px)", color: "#C8D4E8", lineHeight: 1.65, maxWidth: 520, margin: "0 auto 14px" }}>
            We build and run your lead system — cold email, SMS, and calling done for you. First leads in 72 hours.
          </p>

          <p style={{ fontSize: 18, color: "#FFD166", fontWeight: 700, marginBottom: 36 }}>
            $249. 30 days. No contract.
          </p>

          <CTAButton onClick={scrollToCTA}>Claim My 30-Day Pilot — $249 →</CTAButton>

          <p style={{ color: "#7A8FA8", fontSize: 13, marginTop: 16 }}>No retainer. Cancel anytime.</p>

          <div style={{ display: "flex", gap: 48, justifyContent: "center", marginTop: 60, flexWrap: "wrap" }}>
            {[
              { val: "72h", label: "First leads arrive" },
              { val: "30–50+", label: "Conversations/month" },
              { val: "$249", label: "Less than one job" },
            ].map(s => (
              <div key={s.val} style={{ textAlign: "center" }}>
                <div style={{ fontSize: 30, fontWeight: 900, color: "#FF5C2B" }}>{s.val}</div>
                <div style={{ color: "#7A8FA8", fontSize: 13, marginTop: 4 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TIMELINE */}
      <section style={{ background: "#060B17", padding: "80px 24px" }}>
        <div style={{ maxWidth: 840, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 40 }}>
            <Tag color="#FFD166">Timeline</Tag>
            <h2 style={{ fontSize: "clamp(22px,4vw,34px)", fontWeight: 800 }}>72 hours from now, leads are moving.</h2>
          </div>
          <div style={{ maxWidth: 520, margin: "0 auto" }}>
            {[
              { num: "1", title: "Sign up — 5 min", body: "Short form. We start same day." },
              { num: "2", title: "Built in 72h", body: "Sequences loaded, assets ready, campaign live." },
              { num: "3", title: "First leads arrive", body: "Replies within 24–72 hours of launch." },
              { num: "4", title: "We optimize weekly", body: "Better every week for the full 30 days." },
              { num: "5", title: "Day 30 — your call", body: "Continue or stop. No contract. You keep everything." },
            ].map(s => (
              <div key={s.num} style={{ display: "flex", gap: 20, alignItems: "flex-start", marginBottom: 22 }}>
                <div style={{
                  minWidth: 44, height: 44,
                  background: "linear-gradient(135deg,#FF5C2B,#FFD166)",
                  borderRadius: 10, display: "flex", alignItems: "center",
                  justifyContent: "center", fontWeight: 900, fontSize: 18,
                  color: "#0A0F1E", flexShrink: 0,
                }}>{s.num}</div>
                <div>
                  <h3 style={{ fontSize: 16, fontWeight: 700, color: "#F5F7FA", marginBottom: 2 }}>{s.title}</h3>
                  <p style={{ color: "#7A8FA8", fontSize: 14, lineHeight: 1.6, margin: 0 }}>{s.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section id="pricing" style={{ background: "#0A0F1E", padding: "80px 24px" }}>
        <div style={{ maxWidth: 840, margin: "0 auto", textAlign: "center" }}>
          <Tag>Pricing</Tag>
          <h2 style={{ fontSize: "clamp(22px,4vw,34px)", fontWeight: 800, marginBottom: 8 }}>
            One job pays for this. Everything after is profit.
          </h2>
          <p style={{ color: "#7A8FA8", fontSize: 16, marginBottom: 40 }}>Avg job = $300. This costs $249. The math is simple.</p>

          <div style={{
            background: "linear-gradient(135deg,#111827,#0D1525)",
            border: "2px solid #FF5C2B55", borderRadius: 16,
            padding: "48px 40px", maxWidth: 460, margin: "0 auto",
            position: "relative", overflow: "hidden",
          }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 4, background: "linear-gradient(90deg,#FF5C2B,#FFD166)" }} />
            <div style={{ fontSize: 13, fontWeight: 700, color: "#FF5C2B", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 16 }}>30-Day Pilot</div>
            <div style={{ fontSize: 64, fontWeight: 900, color: "#F5F7FA", lineHeight: 1, marginBottom: 4 }}>$249</div>
            <div style={{ color: "#7A8FA8", fontSize: 14, marginBottom: 32 }}>One-time · 30 days · No subscription</div>

            <div style={{ textAlign: "left", marginBottom: 32 }}>
              {[
                "Cold email campaign (written + sent)",
                "SMS follow-up sequences",
                "Cold calling support",
                "Offer & pricing optimization",
                "Weekly tracking + refinement",
                "Free custom website mockup",
              ].map(item => <Check key={item}>{item}</Check>)}
            </div>

            <CTAButton onClick={() => window.open("https://reflexjunk.online/payment", "_self")} fullWidth>
              Claim My Spot — $249 →
            </CTAButton>

            <p style={{ color: "#7A8FA8", fontSize: 12, marginTop: 16 }}>Secure checkout · No hidden fees · Cancel after 30 days</p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section style={{ background: "#060B17", padding: "60px 24px" }}>
        <div style={{ maxWidth: 620, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 32 }}>
            <Tag color="#C8D4E8">FAQ</Tag>
            <h2 style={{ fontSize: "clamp(22px,4vw,30px)", fontWeight: 800 }}>Quick answers</h2>
          </div>

          {[
            { q: "How fast will I see results?", a: "Setup takes 1–3 days. First replies typically within 24–72 hours of launch." },
            { q: "Do I need any experience?", a: "None. We handle everything. Your job is to respond to leads." },
            { q: "Does this work in my city?", a: "Yes — across most US markets." },
            { q: "What happens at day 30?", a: "You decide. Continue or stop — no penalty. You keep everything we built." },
            { q: "Is there a guarantee?", a: "No income guarantees. We guarantee the system is fully built and optimized for 30 days." },
          ].map(item => <FAQItem key={item.q} q={item.q} a={item.a} />)}
        </div>
      </section>

      {/* FINAL CTA */}
      <section style={{
        background: "radial-gradient(ellipse 80% 60% at 50% 100%,#FF5C2B18,transparent), #0A0F1E",
        padding: "80px 24px", textAlign: "center",
      }}>
        <div style={{ maxWidth: 600, margin: "0 auto" }}>
          <h2 style={{ fontSize: "clamp(26px,5vw,42px)", fontWeight: 900, lineHeight: 1.15, marginBottom: 16, letterSpacing: "-0.02em" }}>
            Your competitor is already doing this.{" "}
            <span style={{ background: "linear-gradient(90deg,#FF5C2B,#FFD166)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
              Are you?
            </span>
          </h2>
          <p style={{ color: "#C8D4E8", fontSize: 17, marginBottom: 32 }}>
            $249. 30 days. First leads in 72 hours.
          </p>
          <CTAButton onClick={scrollToCTA}>Stop Losing Jobs — Start My Pilot →</CTAButton>
          <div style={{ display: "flex", gap: 28, justifyContent: "center", marginTop: 32, flexWrap: "wrap" }}>
            {["✓ Done-for-you", "✓ No contract", "✓ Leads in 72h", "✓ $249 flat"].map(t => (
              <span key={t} style={{ color: "#7A8FA8", fontSize: 14 }}>{t}</span>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}